import type { URLPattern as URLPatternClass } from 'urlpattern-polyfill';

// The global is installed by polyfills.ts before any runtime URLPattern use.
// Read via globalThis so this stub never throws at module-eval time on
// browsers that lack native URLPattern (the polyfill loads asynchronously).
// The polyfill declares `class URLPattern` globally, which TS doesn't add to
// `typeof globalThis`, so the read is cast through an augmented globalThis.
// The type-only import is erased before Vite's alias plugin sees it.
export const URLPattern = (globalThis as typeof globalThis & { URLPattern: typeof URLPatternClass }).URLPattern;
